// Replaces all occurences of <span class="coms-sp-title">O<sub>2</sub></span> with a simple "o2" which
// is then displayed as the correct O2 logo in dsONEs "Air" font as a ligature.
export const replaceO2SpanWithAirFontLigature = (node: ShadowRoot | HTMLElement | string) => {
  // You can pass a string in here
  // like <div><span class="coms-sp-title">O<sub>2</sub></span> Produkte</div>
  if (typeof node === 'string') {
    return node.replace(/<span.*?coms-sp-title.*?>O<sub>2<\/sub><\/span>/gi, 'o2');
  }

  node.querySelectorAll<HTMLSpanElement>('span.coms-sp-title').forEach((span$) => {
    if (/o2/.test(span$.innerText.toLowerCase())) {
      span$.innerHTML = 'o2'; // eslint-disable-line no-param-reassign
    }
  });

  return null;
};
